module.exports = __webpack_public_path__ + "img/ana_lucia_sladda.cfde4a74.png";